(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.klaroConsent = {
    attach: function (context, drupalSettings) {
      const btnConsentMap = $('.consent-map', context);
      btnConsentMap.on('click touch', function (){
        const consentStatus = readCookie('klaro') !== null ? readCookie('klaro') : null;
        if(!consentStatus){
          createCookie('klaro', '{"externe_dienste":true}')
        } else {
          const objOldConsent = JSON.parse(consentStatus)
          const objNewConsent = {
            "externe_dienste": true
          }
          $.extend(objOldConsent, objNewConsent)
          const newConsent = JSON.stringify(objOldConsent);
          createCookie('klaro', newConsent, 365);
          setTimeout(()=> {
            location.reload();
            return false;
          }, 100)

        }
      })
    }
  }
})(jQuery, Drupal);
